import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'semantic-ui-react'
import LaneEditorForm from '../LaneEditorForm/LaneEditorForm.jsx'
import { LaneEditorWrapper, TriggerWrapper } from './LaneEditor.styled.js'

export const LaneEditorView = ({
  isVisible,
  propLane,
  toggleEditor,
  closeEditor,
  children,
}) => {
  return (
    <LaneEditorWrapper className='lane-editor'>
      {isVisible && (
        <Modal
          size='small'
          open={true}
          onClose={closeEditor}
          closeOnDimmerClick
          closeOnEscape
        >
          <Modal.Header>
            Lane Editor{propLane?.name ? ` - ${propLane.name}` : ''}
          </Modal.Header>
          <Modal.Content>
            <LaneEditorForm propLane={propLane} onClose={closeEditor} />
          </Modal.Content>
        </Modal>
      )}
      <TriggerWrapper onClick={toggleEditor}>{children}</TriggerWrapper>
    </LaneEditorWrapper>
  )
}

LaneEditorView.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  propLane: PropTypes.object,
  toggleEditor: PropTypes.func.isRequired,
  closeEditor: PropTypes.func.isRequired,
  children: PropTypes.any,
}
